import React from "react";

import Tab from "react-bootstrap/Tab";
// import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";

import "./UserProfileTabSwitcher.css";

import {
  UserTawkOnlyPosts,
  UserAllPosts,
  UserPlaylists,
} from "./UserProfileLoadingLists";

export interface UserProfileTabSwitcherConfig {
  userSub: string;
}

export function UserProfileTabSwitcher(
  props: UserProfileTabSwitcherConfig
): JSX.Element {
  return (
    <div>
      <hr style={{ marginBottom: 0 }} />
      <Tab.Container id="left-tabs-example" defaultActiveKey="first">
        <Nav variant="pills" className="justify-content-center">
          <Nav.Item>
            <Nav.Link key="tawksNavItem" eventKey="first">
              Tawks
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link key="allPostsNavItem" eventKey="second">
              All Posts
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link key="playlists" eventKey="playlists">
              Playlists
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <Tab.Content>
          <hr style={{ marginTop: 0 }} />
          <Tab.Pane key="tawkOnlyPosts" eventKey="first">
            {UserTawkOnlyPosts(props.userSub)}
          </Tab.Pane>
          <Tab.Pane key="allPosts" eventKey="second">
            {UserAllPosts(props.userSub)}
          </Tab.Pane>
          <Tab.Pane key="playlists" eventKey="playlists">
            {UserPlaylists(props.userSub)}
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  );
}
